import { FunctionComponent } from 'react'
import { Box, Typography, rucksack } from '@black-bear-energy/rucksack'
import {
  enableChecklistCategories,
  enableClientDashboard,
  enableSideNavigation,
} from '../../featureFlags'
import {
  isBBEUserOrSuperAdmin,
  isEntityUser,
  useImpersonatingUserOrUser,
} from '../../state/modules/auth'
import { WelcomeHeader } from '../../components/Dashboard/WelcomeHeader'
import { ClientProjectsSection } from './ClientProjectsSection'
import { ReleaseNotes } from './ReleaseNotes'

export const Dashboard: FunctionComponent = () => {
  const user = useImpersonatingUserOrUser()

  // Only client users and Black Bear users see the client dashboard.
  // Channel partner users keep the welcome text and release notes.
  const showClientDashboard =
    enableClientDashboard &&
    !!user &&
    (isEntityUser(user) || isBBEUserOrSuperAdmin(user))

  if (showClientDashboard) {
    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <WelcomeHeader />
        {isEntityUser(user) && <ClientProjectsSection />}
      </Box>
    )
  }

  if (!(enableSideNavigation && enableChecklistCategories)) {
    return null
  }

  return (
    <Box>
      <Typography variant="h4" color={rucksack.palette.text.primary}>
        Welcome to the Black Bear Energy Forager Platform!
      </Typography>
      <Box
        sx={{
          border: '0.5px solid',
          borderColor: rucksack.palette.primary.outlinedBorder,
          borderRadius: rucksack.shape.borderRadius,
          backgroundColor: rucksack.palette.background.card,
          padding: 3,
          marginTop: 2,
        }}
      >
        <ReleaseNotes />
      </Box>
    </Box>
  )
}
